export function setAttribute(selector, key, value) {
    const el = document.querySelector(selector);
    if (el) el.setAttribute(key, value);
}

export function createI18nLink({ locale, href } = {}) {
    const id = `i18n-${locale}`;
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement('link');
        el.id = id;
        el.rel = 'alternate';
        el.hreflang = locale;
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
    el = null;
}

export function createCanonicalLink(href) {
    const id = 'canonical-link';
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement('link');
        el.id = id;
        el.rel = 'canonical';
        el.href = href;
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
    el = null;
}
